import { makeStyles, css } from '@conexasaude/hero'

type GlobalStylesProps = {
  height?: string
}

const globalStyles = makeStyles<GlobalStylesProps>({
  mainContainer: css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    /* mobile viewport bug fix */
    min-height: -webkit-fill-available;
  `,

  typography: ({ typography, colors }) => {
    let styles = ''
    for (let i = 0; i < 6; ++i) {
      const head = 'h' + i
      styles += `
      ${head}{
        font-family: ${typography[head].fontFamily};
        font-size: ${typography[head].fontSize};
        font-weight: ${typography[head].fontWeight};
        line-height: ${typography[head].lineHeight};
        letter-spacing: ${typography[head].letterSpacing};
      }
      `
    }
    return css`
      font-family: ${typography.body1.fontFamily};
      font-size: ${typography.body1.fontSize};
      font-weight: ${typography.body1.fontWeight};
      line-height: ${typography.body1.lineHeight};
      letter-spacing: ${typography.body1.letterSpacing};
      color: ${colors.neutral[900]};
      background: ${colors.extra.background};
      ${styles}
      @keyframes animateLoading {
        0% {
          background-position: -468px 0;
        }
        100% {
          background-position: 468px 0;
        }
      }
      .footer-modal-buttons {
        @media (max-width: 639px) {
          button {
            width: 100%;
          }
        }
      }
    `
  },

  global: (_theme, props) => css`
    .hero-toast_content {
      > span {
        max-width: 367px;
      }
    }

    .chatlayer-chatbox-wrapper {
      max-height: 540px !important;
      left: 0 !important;
      right: unset !important;
      z-index: 9999;

      @media (max-width: 639px) {
        width: 100vw !important;
        height: ${props?.height || '100vh'} !important;
        max-height: unset !important;
      }

      & > .chatlayer-chatbox-button {
        align-self: flex-start !important;
      }
    }

    .chatlayer-chatbox-button {
      display: none !important;
    }

    .chatlayer-iframe {
      @media (max-width: 639px) {
        position: absolute !important;
        top: 0px !important;
        left: 0px !important;
        right: 0px !important;
        width: 100vw !important;
        z-index: 999 !important;
      }
    }
  `,
})

export default globalStyles
